/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HistoryIssueValue
 */
export interface HistoryIssueValue {
    /**
     * 
     * @type {string}
     * @memberof HistoryIssueValue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryIssueValue
     */
    history_type?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryIssueValue
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryIssueValue
     */
    notes?: string;
}

/**
 * Check if a given object implements the HistoryIssueValue interface.
 */
export function instanceOfHistoryIssueValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function HistoryIssueValueFromJSON(json: any): HistoryIssueValue {
    return HistoryIssueValueFromJSONTyped(json, false);
}

export function HistoryIssueValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryIssueValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'history_type': !exists(json, 'history_type') ? undefined : json['history_type'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function HistoryIssueValueToJSON(value?: HistoryIssueValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'history_type': value.history_type,
        'details': value.details,
        'notes': value.notes,
    };
}

